import { BadgeModule } from './BadgeModule.types';

export default {
  addListener: () => {},
  removeListeners: () => {},
} as BadgeModule;
